// removed by extract-text-webpack-plugin
module.exports = {"filtersBlock":"prS2bsPne-pwMa_xNO1j7","columnsMultiselect":"_2X2uYxiftCRtgtosxurdLU","select":"_3w_MutGdzJ02XHiHGN3QTB","spacer":"_1FtgjF-OypDbbt-lh1WR3o","title":"IQaTzWLlUTu18TleDyq6z","priceBlock":"_3j_jZeCfZhsrIWuZPOKKON","price":"_1JeRgXbIv1uuHRGS9gm9qz","search":"_1CTuU4WuXTEzxPWL8nAm6z","searchInput":"_3kKPuUhQviyk4JBAuUb9BP","virtualNumber":"_2oQMRaKV6KP1bxvixclCaK"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ManagePropertiesFilters/ManagePropertiesFilters.scss
// module id = 1629
// module chunks = 0